/* eslint-disable @typescript-eslint/ban-ts-comment */
import {
  Infinity,
  Award03,
  Bookmark,
  Flash,
  Lightbulb05,
  ClockCheck,
  CalendarCheck01,
  MessageChatCircle,
  PlayCircle,
  ChartBreakoutCircle,
  BarChart12,
  CheckHeart,
  UsersCheck,
  FaceWink,
  Building07,
  Stars02,
  Trophy01,
  BookOpen01,
  MessageQuestionCircle,
  MagicWand01,
  HeartHand,
  CheckVerified02,
  Stars01,
  Key01,
  ClockRefresh,
  CoinsHand,
  UserCheck01,
  PenTool01,
  BookClosed,
  Users03,
  Phone,
  LifeBuoy02,
  Building08,
  Mail02,
  Mail01,
} from "@untitled-ui/icons-react";
//@ts-ignore
import React from "react";
import WhatsappIcon from "@icons/whatsappIcon.svg";
import BirebirKoclukIcon from "@icons/birebir_kocluk.svg";
import CanliDerslerIcon from "@icons/canli_dersler.svg";
import CozumluSorularIcon from "@icons/cozumlu_sorular.svg";
import DenemeKulubuIcon from "@icons/deneme_kulubu.svg";
import GrupRehberlikIcon from "@icons/grup_rehberlik.svg";
import KonuVideolariIcon from "@icons/konu_videolari.svg";
import SoruCozumIcon from "@icons/soru_cozum.svg";
import VeliRehberlikIcon from "@icons/veli_rehberlik.svg";
import YayinSetiIcon from "@icons/yayin_seti.svg";

const iconMappings: any = {
  flash: Flash,
  infinity: Infinity,
  "award-03": Award03,
  badge: Award03,
  bookmark: Bookmark,
  "lightbulb-05": Lightbulb05,
  "clock-check": ClockCheck,
  "calendar-check-01": CalendarCheck01,
  chat: MessageChatCircle,
  "play-circle": PlayCircle,
  play: PlayCircle,
  "chart-breakout-circle": ChartBreakoutCircle,
  "bar-chart-12": BarChart12,
  "check-heart": CheckHeart,
  "users-check": UsersCheck,
  "face-wink": FaceWink,
  "building-07": Building07,
  "stars-01": Stars01,
  "stars-02": Stars02,
  "trophy-01": Trophy01,
  "book-open-01": BookOpen01,
  "message-question-circle": MessageQuestionCircle,
  "message-chat-circle": MessageChatCircle,
  "magic-wand-01": MagicWand01,
  "heart-hand": HeartHand,
  "check-verified-02": CheckVerified02,
  "key-01": Key01,
  "clock-refresh": ClockRefresh,
  "coins-hand": CoinsHand,
  "user-check-01": UserCheck01,
  "pen-tool-01": PenTool01,
  "book-closed": BookClosed,
  "users-03": Users03,
  phone: Phone,
  "life-buoy-02": LifeBuoy02,
  whatsapp: WhatsappIcon,
  "building-08": Building08,
  "hearth-hand": HeartHand,
  "mail-01": Mail01,
  "mail-02": Mail02,
  counseling: BirebirKoclukIcon,
  "live-course": CanliDerslerIcon,
  "answered-question": CozumluSorularIcon,
  "mock-test-club": DenemeKulubuIcon,
  "group-counseling": GrupRehberlikIcon,
  "subject-video": KonuVideolariIcon,
  "question-answer": SoruCozumIcon,
  "parent-counseling": VeliRehberlikIcon,
  "mock-test-set": YayinSetiIcon,
};

export function getCmsIcon(key?: string): any {
  if (!key) return React.Fragment;
  if (key === "none") return null;
  return iconMappings[key] || React.Fragment;
}
